export const UPDATE_COLLECTIONS = 'UPDATE_COLLECTIONS';
export const UPDATE_PAGINATOR = 'UPDATE_PAGINATOR';
export const UPDATE_PROFILES = 'UPDATE_PROFILES';
export const SET_CACHED_STATE = 'SET_CACHED_STATE';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';
export const SET_FETCH_STATUS = 'SET_FETCH_STATUS';
